import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineChartComponent } from '@app/shared/module/charts/components/line-chart/line-chart.component';
import { BarChartComponent } from '@app/shared/module/charts/components/bar-chart/bar-chart.component';
import { GroupedBarChartComponent } from '@app/shared/module/charts/components/grouped-bar-chart/grouped-bar-chart.component';
import { StackedBarChartComponent } from '@app/shared/module/charts/components/stacked-bar-chart/stacked-bar-chart.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HorizontalStackedBarChartComponent } from '@app/shared/module/charts/components/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GanttChartComponent } from '@app/shared/module/charts/components/gantt-chart/gantt-chart.component';
import { VerticalStackedBarChartComponent } from '@app/shared/module/charts/components/vertical-stacked-bar-chart/vertical-stacked-bar-chart.component';
import { AreaChartComponent } from '@app/shared/module/charts/components/area-chart/area-chart.component';
import { MatDividerModule } from '@angular/material/divider';


@NgModule({
  declarations: [
    LineChartComponent,
    BarChartComponent,
    StackedBarChartComponent,
    GroupedBarChartComponent,
    HorizontalStackedBarChartComponent,
    VerticalStackedBarChartComponent,
    GanttChartComponent,
    AreaChartComponent,

  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatTooltipModule,
    NgxChartsModule,
    MatDividerModule
  ],
  exports: [
    AreaChartComponent,
    LineChartComponent,
    BarChartComponent,
    StackedBarChartComponent,
    GroupedBarChartComponent,
    GanttChartComponent,
    VerticalStackedBarChartComponent
  ]
})
export class ChartsModule { }
